<template>
  <div class="kui-fieldset">
    <div class="fieldset-legend" :class="[options.theme ? options.theme :'default']">
      <span class="fieldset-legend-icon"><i class="el-icon-edit"></i></span>
      <span class="fieldset-legend-title">{{options.title}}</span>
      <span class="fieldset-legend-toolbar"></span>
    </div>
    <div class="kui-fieldset-wrap">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import fieldset from "./src/fieldset";
export default fieldset;
</script>
<style lang='less' scoped>
.kui-fieldset {
  .fieldset-legend.default {
    height: 45px;
    line-height: 45px;
    background: #2e79db;
    border-radius: 3px;
    color: #fff;
    margin: 10px 0;
    .fieldset-legend-icon {
      text-align: center;
      margin-left: 10px;
      font-size: 22px;
    }
    .fieldset-legend-title {
      font-size: 24px;
      font-weight: bold;
    }
  }
  .fieldset-legend.concise {
    background: #fff;
    color: #000;
    line-height: 40px;
    height: 40px;
    padding: 0 10px;
    position: relative;
    .fieldset-legend-icon {
      display: none;
    }
    .fieldset-legend-title {
      font-size: 24px;
      color: #2e79db;
      margin-left: 27px;
      font-weight: bold;
    }
    .fieldset-legend-toolbar {
      display: none;
    }
    &:before {
      content: "";
      display: inline-block;
      width: 8px;
      height: 24px;
      left: 13px;
      top: 50%;
      margin-top: -12px;
      background: #2e79db;
      position: absolute;
    }
  }

  .kui-fieldset-wrap {
    padding: 5px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/fieldset/index.vue